import {Injectable} from '@angular/core';
import {HttpClient} from './http-client.service';
import {Logger} from '../logger.service';
import {Observable,Observer} from 'rxjs';
import {Response} from '@angular/http';

@Injectable()
export class SaleableSeatApi {
	constructor(private httpClient: HttpClient, private logger: Logger) {

	}
	private temp: number = 500;

	public updateSaleableSeats(url: string, categoryId: number, amount: number) {
		this.temp = amount;
		return Observable.create((observer:Observer<string>) => {
				observer.next("next")
				observer.complete();
		})
	}

	public getAmountOfSeats(eventUrl: string): Observable<SaleableSeatsAvailability[]> {
		return Observable.from(
			[
				[
					{
						categoryName: "Test Kategorie 1",
						saleableSeatAmount: {
							total: 500,
							free: 200,
							sold: 300
						},
						categoryId: 1234

					}, {
						categoryName: "Kategorie GT 2",
						saleableSeatAmount: {
							total: 400,
							free: 200,
							sold: 200
						},
						categoryId: 1235
					}, {
						categoryName: "Kategorie GT 3223",
						saleableSeatAmount: {
							total: 0,
							free: 0,
							sold: 0
						},
						categoryId: 1236
					} , {
						categoryName: "Kategorie Abc DeF",
						saleableSeatAmount: {
							total: 20,
							free: 0,
							sold: 0
						},
						categoryId: 1236
					}
				]
			]
		)
	}

}

export class SaleableSeatsAmount {
	total: number
	free: number
	sold: number
}

export class SaleableSeatsAvailability {
	categoryName: string
	categoryId : number
	saleableSeatAmount: SaleableSeatsAmount
}


// WEBPACK FOOTER //
// ./src/app/services/webservice/saleableseat-api.service.ts